import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    open: false
  },
  reducers: {
    showCart: () => ({ open: true }),
    hideCart: () => ({ open: false })
  }
})

export const { showCart, hideCart } = cartSlice.actions

export default cartSlice.reducer